(function () {
  const initCollapsibleContent = () => {
    $(".collapsible-content__toggle").each(function (index, element) {
      if ($(this).hasClass("content_started")) {
        return "";
      }
      $(this).addClass("content_started");
      $(element).on("click", function () {
        const $toggle = $(this);
        const $item = $toggle.closest(".collapsible-content__item");
        const $group = $toggle.closest(".collapsible-content__items");
        const $answer = $item.find(".collapsible-content__answer").first();

        if (!$item.hasClass("active")) {
          $group.find(".collapsible-content__item.active").removeClass("active");
          $group.find(".collapsible-content__toggle").attr("aria-expanded", "false");
          $group.find(".collapsible-content__answer").stop().slideUp(300);
          $item.addClass("active");
          $toggle.attr("aria-expanded", "true");
          $answer.stop().slideDown(300);
        } else {
          $item.removeClass("active");
          $toggle.attr("aria-expanded", "false");
          $answer.stop().slideUp(300);
        }
      });
    });
  };

  document.addEventListener("shopify:section:load", function () {
    initCollapsibleContent();
  });

  initCollapsibleContent();
})();
